<template>
  <v-app>
    <v-container fluid class="mt-16 pt-16">
      <v-row>
        <v-col align="center" class="text-h5 warning-text">Sorry, but we cannot find a distillery that you have access to</v-col>
      </v-row>
      <v-row class="mt-16">
        <v-col align="center"><v-btn @click="$auth.login()" plain small>Back to sign in</v-btn></v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>

export default {
  name: 'NoDistillery',
  created() {
    this.$auth.logout();
    this.$store.commit('clearUser');
  }
}
</script>